/* =========================================================================
   WARMBELT CO — image sections helper (self-contained, scoped, conflict-free)
   - Reveals .reveal / [data-stagger] INSIDE wb sections only.
   - Handles subtle parallax via [data-wb-parallax] (own attribute, so it
     never fights the theme's own [data-parallax] handler).
   - Reduced-motion aware. Re-inits on Theme Editor section load/select.
   Storefront weight: ~1.5kb, no dependencies.
   ========================================================================= */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SCOPE = '[data-section-type^="wb-"]';

  function sections(root) {
    if (root && root.matches && root.matches(SCOPE)) return [root];
    return Array.prototype.slice.call((root || document).querySelectorAll(SCOPE));
  }

  /* ---- scroll reveal + stagger (scoped) ---- */
  function staggerChildren(el) {
    Array.prototype.slice.call(el.children).forEach(function (ch, i) {
      ch.style.transitionDelay = (i * 80) + 'ms';
    });
  }
  function reveal(root) {
    var els = [];
    sections(root).forEach(function (sec) {
      Array.prototype.slice.call(sec.querySelectorAll('.reveal, [data-stagger]'))
        .forEach(function (el) { els.push(el); });
    });
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute('data-stagger')) staggerChildren(el);
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        if (el.hasAttribute('data-stagger')) staggerChildren(el);
        el.classList.add('is-visible');
      } else {
        io.observe(el);
      }
    });
  }

  /* ---- subtle parallax (scoped, own attribute) ---- */
  var plx = [], praf;
  function collectParallax(root) {
    sections(root).forEach(function (sec) {
      Array.prototype.slice.call(sec.querySelectorAll('[data-wb-parallax]'))
        .forEach(function (el) { if (plx.indexOf(el) === -1) plx.push(el); });
    });
  }
  function onScroll() {
    if (reduce || !plx.length) return;
    cancelAnimationFrame(praf);
    praf = requestAnimationFrame(function () {
      var vh = window.innerHeight;
      plx.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-wb-parallax')) || 0.08;
        var off = (r.top + r.height / 2) - vh / 2;
        el.style.transform = 'translate3d(0,' + (off * -speed) + 'px,0) scale(1.12)';
      });
    });
  }

  function init(root) {
    reveal(root);
    collectParallax(root);
    onScroll();
  }

  function ready(fn) {
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn) : fn();
  }
  ready(function () {
    init(document);
    if (!reduce) window.addEventListener('scroll', onScroll, { passive: true });
  });

  /* Theme Editor lifecycle */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { reveal(e.target); });
})();
